import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { timeout: { type: Number, default: 9000 } }

  initialize() {
    this.autoDismissSnackbar = this.autoDismissSnackbar.bind(this)
  }

  connect() {
    document.addEventListener('turbo:load', this.autoDismissSnackbar)
  }

  disconnect() {
    document.removeEventListener('turbo:load', this.autoDismissSnackbar)
  }

  autoDismissSnackbar() {
    let snackBarEl = this.element
    setTimeout(() => { snackBarEl.style.display = 'none' }, this.timeoutValue)
  }
}
